import React from 'react';
import { LoadMore } from '../loadMore';
import { StandardArticleCustom } from '../../../../app/component/standardArticleCustom';
import './authorArticles.css';

export default function ({ authorArticles, author, nextOffset, total, onLoadMoreClick }) {
  return (
    <div className="section author-articles">
      {authorArticles.length > 0 ? (
        <div className="container">
          <div className="author-data">
            <img
              src={
                author.picture
                  ? `https://data.tvkosice.sk/images/cm/200x200xmedia/${author.picture}`
                  : '/assets/avatar.png'
              }
              alt={`Fotografia autora ${author.name}`}
              className="author-image"
            />
            <span className="author-name">
              Všetky články od autora <strong>{author.name}</strong>
            </span>
          </div>
          <div className="row flex-row">
            {authorArticles.map((item) => {
              return (
                <div
                  key={item._id}
                  className="flex-col col-xs-12 col-sm-6 col-md-3"
                >
                  <StandardArticleCustom extended={true} article={item} />
                </div>
              );
            })}
          </div>
          {nextOffset !== total && (
            <div className="text-center section">
              <LoadMore show={true} onClick={onLoadMoreClick} />
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ui/src/component/authorArticles/authorArticles.js